// extracted by mini-css-extract-plugin
export default {"contentWrapper":"contentWrapper__contentWrapper___ucjoZ"};